import { render, staticRenderFns } from "./ChartDataItemMobile.vue?vue&type=template&id=678e9d8a&scoped=true"
import script from "./ChartDataItemMobile.vue?vue&type=script&lang=js"
export * from "./ChartDataItemMobile.vue?vue&type=script&lang=js"
import style0 from "./ChartDataItemMobile.vue?vue&type=style&index=0&id=678e9d8a&prod&scoped=true&lang=css"
import style1 from "./ChartDataItemMobile.vue?vue&type=style&index=1&id=678e9d8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e9d8a",
  null
  
)

export default component.exports